// Silences the benign "ResizeObserver loop completed with undelivered
// notifications." warning that react-scripts' dev overlay turns into a
// full-screen "Uncaught runtime errors" panel covering the app.
//
// Radix UI's popper components (Select / DropdownMenu / Popover / Tooltip)
// observe element sizes to position themselves, and mutate layout inside the
// observer callback while repositioning. The browser then occasionally can't
// deliver every resize within one frame and emits the warning. It is harmless
// (it never fires in a production build), but the dev overlay treats any window
// `error` as fatal and blocks the page.
//
// Deferring each ResizeObserver callback to the next animation frame moves the
// layout work out of the observer's delivery cycle, so the loop is spread across
// frames and the warning is never produced. The one-frame defer is
// imperceptible and changes no behaviour — Radix measures its initial position
// synchronously on open, not via the observer.
if (typeof window !== "undefined" && window.ResizeObserver) {
  const NativeResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class ResizeObserver extends NativeResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => callback(entries, observer));
      });
    }
  };
}

// Defense in depth: if a benign ResizeObserver loop warning still reaches the
// window (e.g. from a dependency that captured the native observer before this
// module ran), stop it in the capture phase so it never bubbles to the
// dev-server overlay's error handler.
if (typeof window !== "undefined") {
  window.addEventListener(
    "error",
    (event) => {
      if (
        typeof event.message === "string" &&
        event.message.startsWith("ResizeObserver loop")
      ) {
        event.stopImmediatePropagation();
        event.preventDefault();
      }
    },
    true
  );
}
